/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-06-11 17:14:12
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-12 10:29:05
 */

// import wx from '@/utils/wx'

const storageObj = {
  set: function (key, items) {
    window.localStorage.setItem(key, JSON.stringify(items))
  },
  get: function (key) {
    var val = window.localStorage.getItem(key)
    // val = val ? JSON.parse(val) : val
    return val
  },
  remove: function (key) {
    window.localStorage.removeItem(key)
  }
}

export default storageObj
